import { getParams } from '@/utils/params';

export const getImgBaseUrl = () => getParams().imageServiceEndPoint;
